<template>

  <span>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-tabs :value="active_step" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none"
                 id="profile-tabs" :key="isSmallerScreen">
          <vs-tab icon-pack="feather" icon="icon-toggle-left" :label="!isSmallerScreen ? 'System Pick Lists' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
              <system-pick-lists/>
            </div>
          </vs-tab>
           <vs-tab disabled icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'Notification Events' : ''">
            <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">

            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </span>
</template>

<script>

  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  const CustomerRepository = RepositoryFactory.get('customer');

  import SystemPickLists from './General/SystemPickLists.vue'

  export default {
    components: {
      SystemPickLists
    },
    data() {
      return {
        active_step: this.$route.query.step ? this.$route.query.step : '0'
      }
    },
    computed: {
      isSmallerScreen() {
        return this.$store.state.windowWidth < 768
      }
    },
    methods: {}
  }
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
